import { Injectable } from '@angular/core';
import { BookingPaymentOverride } from 'models';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class BookingPaymentOverrideService {
    constructor(private http: HttpClient) { }
  
    get(): Observable<BookingPaymentOverride> {
        return this.http.get<BookingPaymentOverride>(`api/bookingpaymentoverride/get/`);
    }

    save(lastMinuteBookingOverride: BookingPaymentOverride): Observable<BookingPaymentOverride> {
        return this.http.post<BookingPaymentOverride>('api/bookingpaymentoverride/post', lastMinuteBookingOverride);
    }   
}